import {
  FormBaseType,
  FormBasicsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_AVAILIBLE_FORMS = "GET_AVAILIBLE_FORMS";
interface GetAvailableForms {
  formBaseTypes: FormBaseType[];
  procurementSupplierId?: string;
}

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const fetchAvailableForms = async ({
  formBaseTypes,
  procurementSupplierId,
}: GetAvailableForms): Promise<FormBasicsDto[]> => {
  const response = await formsApi.formsControllerGetAvailableForms(
    formBaseTypes,
    procurementSupplierId,
  );

  return response.data;
};

export const useGetAvailableForms = (
  user: UserProfileDto | null,
  formBaseTypes: FormBaseType[],
  procurementSupplierId?: string,
): {
  availableForms: FormBasicsDto[] | undefined;
  availableFormsEnabled: boolean;
  formsError: Error | null;
  refetchAvailibleForms: () => void;
  isLoadingAvailableForms: boolean;
  isFetchingAvailableForms: boolean;
  isSuccessAvailableForms: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const isSupplier = formBaseTypes.includes(FormBaseType.ProcurementSupplier);

  const queryResult = useQuery<FormBasicsDto[], Error>({
    queryKey: [
      DOMAIN_FORMS,
      ACTION_GET_AVAILIBLE_FORMS,
      formBaseTypes,
      procurementSupplierId ?? null,
    ],
    queryFn: () => fetchAvailableForms({ formBaseTypes, procurementSupplierId }),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled: !isSupplier || Boolean(procurementSupplierId),
  });

  return {
    availableForms: queryResult.data,
    availableFormsEnabled: enabled,
    formsError: queryResult.error,
    refetchAvailibleForms: queryResult.refetch,
    isLoadingAvailableForms: queryResult.isLoading,
    isFetchingAvailableForms: queryResult.isFetching,
    isSuccessAvailableForms: queryResult.isSuccess,
  };
};
